import React from "react";
import PlayerAvatar from "./PlayerAvatar";

const PodiumCard = ({ name, profile_url, RankImage, gradient, points ,StarRank , blueDiv }) => {
  return (
    <div className="flex flex-col items-center">
      <div
        className="flex flex-col items-center mb-0 w-[170px] md:w-[200px] rounded-2xl"
        style={{
          background: gradient,
        }}
      >
        <div className="relative pt-8 w-full">
          <PlayerAvatar
            name={name}
            imageUrl={profile_url}
            // size="lg"
          />
          {/* Rank bookmark for 3rdplace */}
          {/* <div className="absolute top-0 right-5">
            {RankImage}
          </div> */}
        </div>
        <p className="text-white text-[16px] font-[Lato] text-center max-w-[150px] truncate">
          {name || "Unknown Player"}
        </p>
        <div className="mt-1 mb-4">
          <div className="bg-white rounded-full px-2 py-1 flex items-center gap-2">
            {StarRank} 
            <p className="text-[#BFBFBF] text-[14px] font-[Lato] font-[600]">
              {points || 0} Points
            </p>
          </div>
        </div>
      </div>
      {/* Podium base */}
      {blueDiv}
    </div>
  );
};

export default PodiumCard;
